module.exports = __webpack_public_path__ + "static/media/logo1.6d38e26d.webp";